import React from 'react';
import c from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import ArrowLeftIconNew from '../../../Icons/ArtStageArrowL';
import commonStyles from '../../Slider.scss';
const DefaultPreviousButton = ({ onClick, className, iconClassName, arrowSize = IconSize.LARGE })=>{
    return /*#__PURE__*/ React.createElement("button", {
        className: c(commonStyles['prev-btn'], className),
        onClick: onClick,
        /**
       * We can hide these from screen readers because they have
       * access to all of the slider content without these buttons
       */ "aria-hidden": true,
        /**
       * Still adding an aria-label to avoid getting pinged by automated a11y tools
       */ "aria-label": 'Previous'
    }, /*#__PURE__*/ React.createElement(ArrowLeftIconNew, {
        withPadding: false,
        className: c(commonStyles['arrow-icon'], iconClassName),
        size: arrowSize
    }));
};
DefaultPreviousButton.displayName = 'DefaultPreviousButton';
export default DefaultPreviousButton;

//# sourceMappingURL=DefaultPreviousButton.js.map